import { useCdnImageSrc } from 'util/cdnDisplayUrl';
import { testAbsoluteUrl } from 'util/testAbsoluteUrl';
import React, { ReactElement } from 'react';
import { APP_URL } from 'config/app.config';

export type ImageProps = {
  alt: string;
  src: string;
  styles?: React.CSSProperties;
  priority?: boolean;
} & React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

export const Image = ({
  src,
  style,
  width,
  loading,
  priority,
  onError,
  ...props
}: ImageProps): ReactElement => {
  const url = testAbsoluteUrl(src) ? src : `${APP_URL ?? ''}${src}`;
  const numericWidth =
    typeof width === 'number'
      ? width
      : typeof width === 'string'
        ? Number(width) || undefined
        : undefined;
  const { src: displaySrc, onError: onThumbError } = useCdnImageSrc(
    url,
    numericWidth,
  );

  style = {
    objectFit: 'cover',
    ...style,
  };

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      {...props}
      src={displaySrc}
      style={style}
      width={width}
      loading={priority ? 'eager' : loading ?? 'lazy'}
      decoding="async"
      onError={event => {
        const img = event.currentTarget;
        const exhausted = onThumbError();
        if (!exhausted && url) {
          if (img.src !== url) img.src = url;
          return;
        }
        img.onerror = null;
        onError?.(event);
      }}
    />
  );
};
